export default "__VITE_ASSET__09f7459d__"